import React, {Component} from 'react';
import { Sprite, Container, Text, withPixiApp } from '@inlet/react-pixi';
import * as PIXI from 'pixi.js';
import constants from '../Constants'

class Mover extends Component {

  state = { value: 0 }
  counter = 0

  componentDidMount() {
    this.setState({ value: this.props.from })
    this.props.app.ticker.add(this.tick)
  }

  componentWillUnmount() {
    this.props.app.ticker.remove(this.tick)
  }

  tick = (delta) => {
    const { ease, from, to, speed } = this.props

    this.counter += speed * delta
    const value = from + (to-from) / 2 + ease(this.counter) * (from - to) / 2

    this.setState({ value })
  }

  render() {
    return this.props.children({value: this.state.value, i: this.counter});
  }
}

const MoverWithApp = withPixiApp(Mover)

class Pulse extends Component {

  state = { value: 0 }
  counter = 0

  componentDidMount() {
    this.setState({ value: this.props.from })
    this.props.app.ticker.add(this.tick)
  }

  componentWillUnmount() {
    this.props.app.ticker.remove(this.tick)
  }

  tick = (delta) => {
    const { ease, from, to, speed } = this.props

    this.counter += speed * delta
    const value = from + (to-from) / 2 + ease(this.counter) * (from - to) / 2

    this.setState({ value })
  }

  render() {
    return this.props.children({value: this.state.value, i: this.counter});
  }
}

const PulseWithApp = withPixiApp(Pulse);

const styleIndicator = new PIXI.TextStyle({
  fontFamily: 'Arial',
  fontSize: 14,
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 20,
  textBaseline: 'alphabetic',
  fill: ['#FFFFFF', '#FFFFFF'], // gradient
  stroke: '#FFF',
  strokeThickness: 0,
  dropShadow: true,
  dropShadowColor: '#000000',
  dropShadowBlur: 4,
  dropShadowAngle: 45,
  dropShadowDistance: 0
});

export class StoneContainer extends Component {

  constructor(props) {
    super(props);

    this.stoneBounds = { w:548/2, h:864/2 };
    this.clipBounds = { w:128, h:128 };

    this.rock = React.createRef();

    this.state = {
      enabled: true,
      sw: 0,
      sh: 0,
      width: 411,
      height: 648,
      speed: 0,
      x: 0,
      y: 0,
      scale: [.75,.75],
      alpha: 1,
      anchor: [0.5,0.5],
      totalDigits: 0,
      button_1_state: 'off',
      button_2_state: 'off',
      button_3_state: 'off',
      button_4_state: 'off',
      button_5_state: 'off',
      button_6_state: 'off',
      button_7_state: 'off',
      button_8_state: 'off',
      button_9_state: 'off',
      button_10_state: 'off',
      button_11_state: 'off',
      button_12_state: 'off',
      button_13_state: 'off',
      rockButtons: [
        { clipRect:new PIXI.Rectangle(30,210,128,128),
          name:'button_1',
          pos:{ x:30 - this.stoneBounds.w, y:210 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(195,204,145,128),
          name:'button_2',
          pos:{x:195 - this.stoneBounds.w,y:204 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(358,189,128,128),
          name:'button_3',
          pos:{x:358 - this.stoneBounds.w,y:189 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(16,345,140,128),
          name:'button_4',
          pos:{x:16 - this.stoneBounds.w,y:345 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(211,337,128,128),
          name:'button_5',
          pos:{x:211 - this.stoneBounds.w,y:337 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(370,324,128,128),
          name:'button_6',
          pos:{x:370 - this.stoneBounds.w,y:324 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(35,482,128,128),
          name:'button_7',
          pos:{x:35 - this.stoneBounds.w,y:482 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(210,483,128,135),
          name:'button_8',
          pos:{x:210 - this.stoneBounds.w,y:483 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(370,474,128,128),
          name:'button_9',
          pos:{x:370 - this.stoneBounds.w,y:474 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(116,600,128,128),
          name:'button_10',
          pos:{x:116 - this.stoneBounds.w,y:600 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(272,600,128,128),
          name:'button_11',
          pos:{x:272 - this.stoneBounds.w,y:600 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(131,730,128,128),
          name:'button_12',
          pos:{x:131 - this.stoneBounds.w,y:730 - this.stoneBounds.h} },
        { clipRect:new PIXI.Rectangle(282,730,128,128),
          name:'button_13',
          pos:{x:282 - this.stoneBounds.w,y:730 - this.stoneBounds.h} },
      ],
      currentCodeEntered: '',
      validCodeSent: false,
      validCodesTriggered: [],
      cookingTipsCursor: 0,
      currentMsg: '',
      isRepeatTriggered: '',
      toggleAudioSequence: false,
      animationMap: [] // For what to do when code is OK ! or notOK or a REPEAT trigger.
    }
  }

  componentDidMount() {
    this.updateStonePosition();
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if ( prevState.sw !== nextProps.screen.sw ||
      prevState.sh !== nextProps.screen.sh ) {
      return {
        sw: nextProps.screen.sw,
        sh: nextProps.screen.sh
      };
    }
    return null;
  }

  updateStonePosition = () => {

    // the stage bounds w/h
    let stageWidth = window.innerWidth;
    let stageHeight = window.innerHeight;
    // the rocks w/h
    let width = this.rock.current.width;
    let height = this.rock.current.height;
    // new w/h
    let newW = 0;
    let newH = 0;
    // cap w/h - based on graphic size.
    let maxWidth = 411;
    let maxHeight = 648;

    // check if height or width is below a threshold and
    // add margins if needed
    if( stageWidth < 500 ) {
      stageWidth = stageWidth - 80;
    }
    if( stageHeight < 600 ) {
      stageHeight = stageHeight - 40;
    }

    let rectRatio = width / height;
    let boundsRatio = stageWidth / stageHeight;

    if(rectRatio > boundsRatio) {
      newW = stageWidth;
      newH = height * (stageWidth / width);
    }
    else {
      newW = width * (stageHeight / height);
      newH = stageHeight;
    }

    this.setState({
      width: ( newW > maxWidth ) ? maxWidth : newW ,
      height: ( newH > maxHeight ) ? maxHeight : newH
    })

  }

  shouldComponentUpdate(nextProps, nextState) {
    if ( this.state !== nextState ) {
      return true
    } else {
      return false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.sw !== window.innerWidth ||
      prevState.sh !== this.props.screen.sh
    ) {
      this.updateStonePosition();
    }
  }

  // SEARCH -> constants.CODE_OBJ[] code is in c contains
  // will return { c:STRING, v:STRING, r:BOOL, a:STRING } || false
  validateCurrentCode = () => {
    // console.log('CHECK CURR: validateCurrentCode: ', this.state.currentCodeEntered)
    let c = this.state.currentCodeEntered;
    let obj = null;
    for (let i = 0; i < constants.CODE_OBJ.length; i++) {
      // console.log( 'TESTING CODE: ' , constants.CODE_OBJ[i].c,  c )
      if( constants.CODE_OBJ[i].c === c ) {
        obj = constants.CODE_OBJ[i];
        break;
      }
    }
    return ( obj !== null ) ? obj : false;
  }

  // will return { c:STRING, v:STRING, r:BOOL, a:STRING } || false
  validateCodesTriggered = () => {
    // console.log('CHECK PREV: validateCodesTriggered: ', this.state.currentCodeEntered, this.state.validCodesTriggered)
    let c = this.state.currentCodeEntered;
    let obj = null;
    for (let i = 0; i < this.state.validCodesTriggered.length; i++) {
      if( this.state.validCodesTriggered[i].c === c ) {
        obj = this.state.validCodesTriggered[i];
        break;
      }
    }
    return ( obj !== null ) ? obj : false;
  }

  // for display purposes ( ie: press down )
  onEnterButtonDown = (e) => {
    // console.log('ONBTN ENTER DOWN: BTN V: ', e.currentTarget.btnValue)
    let target = e.currentTarget.name;
    let found = this.validateCurrentCode();

    this.setState((prevState) => {
      return { [ target + '_state'] : 'on', validCodeSent: found, enabled: false }
    }, () => {
      if (found) {
        this.props.playUIAudio('btn_send_success');
      } else {
        this.props.playUIAudio('btn_send_fail');
      }
    });
  }

  // check and validate and also see if its been pressed before
  onEnterButtonUp = (e) => {

    // console.log('Starting Enter Btn test')

    let target = e.currentTarget.name;
    let found = this.state.validCodeSent;

    // found ?
    // N - play wrong sound noise
    // exit
    // Y - continue
    // has it been played before ?
    // Y - play something maybe error
    // N - continue
    // is repeatable set to true ?
    // N - play audio file for code
    //   - set audio as played
    // Y - send audio array to the player
    // exit

    if( found !== false ) {

      // console.log('The code is correct', this.validateCodesTriggered())

      if( this.validateCodesTriggered() === false ) {

        // short circuit play logic if its 9_8_10_4_1_10_6_
        if( found.r === true && found.a1 === '9_8_10_4_1_10_6' ) {

          //console.log('CODE FOUND -> ', found );
          this.setState((prevState) => {
            return {
              [ target + '_state'] : 'off',
              toggleAudioSequence: !this.state.toggleAudioSequence,
              totalDigits: 0
            }
          }, () => {
            this.props.playAudioFile( ( this.state.toggleAudioSequence ) ? found.a1 : found.a2, 3 );
            this.triggeredAnimation({ type:'ok', codeObj:found, useAudio2: this.state.toggleAudioSequence });
          })
        }

        // console.log('The code is correct and we never played this audio before. Check if its a cooking tip')
        if( found.r === true ) {

          // console.log('The code is correct and we never played this audio before but its REPEATABLE - cookingTips')
          // -------------------------------
          // Add a cursor to the found object so we know which to play
          // on start cursor is at 0
          found['playAt'] = this.state.cookingTipsCursor;
          this.props.playAudioFile(found, 2);
          this.triggeredAnimation({ type:'ok', codeObj:found, useAudio2:false });
          // -------------------------------
          this.setState((prevState) => {
            return {
              [ target + '_state'] : 'off',
              currentCodeEntered: '',
              currentMsg: found.v,
              isRepeatTriggered: '',
              totalDigits: 0,
              cookingTipsCursor: ( ( this.state.cookingTipsCursor + 1 ) >= found.a2.length ) ? 0 : this.state.cookingTipsCursor + 1
            }
          }, () => {

          })

        } else {

          // console.log('The code is correct and we never played this audio before its not a cooking tip lets play it !')
          // -------------------------------
          this.setState((prevState) => {
            let newList = prevState.validCodesTriggered.slice()
            newList.push(found)
            return {
              [ target + '_state'] : 'off',
              validCodesTriggered: newList,
              currentCodeEntered: '',
              currentMsg: found.v,
              isRepeatTriggered: '',
              totalDigits: 0
            }
          }, () => {
            this.props.playAudioFile(found, 1);
            this.triggeredAnimation({ type:'ok', codeObj:found, useAudio2:false });
          })
          // -------------------------------
        }

      } else {
        // console.log('The code is correct but we already played this audio before')
        this.setState((prevState) => {
          return { currentCodeEntered: '', [ target + '_state'] : 'off', enabled: true, totalDigits: 0 };
        })
        this.triggeredAnimation({ type:'error' });
      }
    } else {
      // console.log('The code is incorrect')
      this.setState((prevState) => {
        return { currentCodeEntered: '', [ target + '_state'] : 'off', enabled: true, totalDigits: 0 };
      })
      this.triggeredAnimation({ type:'error' });
    }

    return null
  }

  onResetButtonDown = (e) => {
    if( this.state.enabled === false ) return
    let target = e.currentTarget.name;
    this.setState((prevState) => {
      return { [ target + '_state'] : 'on' };
    }, () => {
      this.props.playUIAudio('btn_12');
    })
  }

  onResetButtonUp = (e) => {
    if( this.state.enabled === false ) return
    let target = e.currentTarget.name;
    this.setState((prevState) => {
      return {
        [ target + '_state'] : 'off',
        currentCodeEntered: '',
        totalDigits: 0
      };
    })
  }

  onButtonDown = (e) => {
    if( this.state.enabled === false ) return
    let target = e.currentTarget.name;
    this.setState((prevState) => {
      // let oldCode = prevState.currentCodeEntered; ?
      let newCode = prevState.currentCodeEntered + e.currentTarget.btnValue;
      let newTotalDigits = this.state.totalDigits + 1;

      if (newTotalDigits > 14) newTotalDigits = 14;

      return { [ target + '_state'] : 'on',
        currentCodeEntered: newCode,
        totalDigits: newTotalDigits };
    }, () => {
      let audioId = 'btn_' + target.split('_')[1];
      this.props.playUIAudio(audioId);
    })
  }

  onButtonUp = (e) => {
    if( this.state.enabled === false ) return
    let target = e.currentTarget.name;
    this.setState((prevState) => {
      return { [ target + '_state'] : 'off' };
    })
  }

  onButtonOver = (e) => {
    if( this.state.enabled === false ) return
    let target = e.currentTarget.name;
    this.setState((prevState) => {
      return { [ target + '_state'] : 'over' };
    })
  }

  onButtonOut = (e) => {
    if( this.state.enabled === false ) return
    let target = e.currentTarget.name;
    this.setState((prevState) => {
      return { [ target + '_state'] : 'off' };
    })
  }

  triggeredAnimation = ( animationObj ) => {
    if( animationObj.type === 'error' ) {
      // console.log('triggeredAnimation for wrong code' );
    } else {
      // console.log('triggeredAnimation OK code entry with these values -> ', animationObj );
    }
  }

  getTexture = ( clipRect, name ) => {
    let originalClipRect = new PIXI.Rectangle(0,0,365,577);
    let onTexture   = new PIXI.Texture( this.props.texture[1], clipRect, originalClipRect );
    let overTexture = new PIXI.Texture( this.props.texture[2], clipRect, originalClipRect );
    let offTexture  = new PIXI.Texture( this.props.texture[0], clipRect, originalClipRect );

    switch( this.state[name + '_state'] + 'Texture' ) {
      case 'onTexture':
        return onTexture
      case 'overTexture':
        return overTexture
      case 'offTexture':
        return offTexture
      default:
        return offTexture
    }
  }

  generateBtnSprite = ( clipRect, name, pos, codeValue, type ) => {

    let btnPressDown = undefined;
    let btnPressUp   = undefined;

    if( type === 'btn' ) {
      btnPressDown = this.onButtonDown
      btnPressUp   = this.onButtonUp
    }
    if( type === 'enter' ) {
      btnPressDown = this.onEnterButtonDown
      btnPressUp   = this.onEnterButtonUp
    }
    if( type === 'reset' ) {
      btnPressDown = this.onResetButtonDown
      btnPressUp   = this.onResetButtonUp // this.clearCurrentMsg
    }

    let sprite = (

      <PulseWithApp key={ 'rock_' + name } from={0.5} to={1.3} ease={ Math.sin } speed={ 0.1 }>
        {({ value, i }) => {
          return <Sprite texture={this.getTexture(clipRect, name)}
                         x={pos.x}
                         y={pos.y}
                         key={name}
                         name={name}
                         alpha={value}
                         btnValue={codeValue}
                         interactive={true}
                         buttonMode={true}
                         pointerdown={btnPressDown}
                         pointerup={btnPressUp}
                         pointerover={this.onButtonOver}
                         pointerout={this.onButtonOut}
          />
        }}
      </PulseWithApp>
    )

    return sprite;
  }

  generateRockBtns = () => {
    let spArray = [];
    this.state.rockButtons.forEach((item, i) => {
      if( i <= 10 ) {
        spArray.push(
          this.generateBtnSprite(item.clipRect, item.name, item.pos, (i+1) + '_', 'btn'))
      } else {
        if( i === 11 ) {
          spArray.push(
            this.generateBtnSprite(item.clipRect, item.name, item.pos,
              (i + 1) + '_', 'reset'))
        }
        if( i === 12 ) {
          spArray.push(
            this.generateBtnSprite(item.clipRect, item.name, item.pos,
              (i + 1) + '_', 'enter'))
        }
      }
    });
    return spArray;
  }

  clearCurrentMsg = () => {
    this.setState({
      currentCodeEntered: '',
      currentMsg: '',
      isRepeatTriggered: '',
      enabled: true
    });
  }

  generateDigits = () => {

    let totalDigits = this.state.totalDigits;
    let xStart = 10;
    let hSpacing = 20;
    let digits = [];

    var step;
    for (step = 0; step < totalDigits; step++) { // 0 - 4
      digits.push(
        <Sprite texture={this.props.texture[3]}
                key={'digit_' + step}
                scale={[1,1]}
                alpha={1}
                x={ xStart + (step * hSpacing) - (hSpacing * totalDigits * 0.5) }
                y={ 140 - this.stoneBounds.h }
                anchor={[0.5,0.5]}
        />
      )
    }

    return digits
  }

  render() {
    return (
      <Container>
        <MoverWithApp c={this.props.c} from={this.state.sw * 0.5} to={this.state.sw * 0.5 + 20} ease={ Math.sin } speed={ 0.018 }>

          {({ value, i }) => (
            <Container ref={this.rock}
                       name={"stone-container"}
                       x={this.state.sw * 0.5}
                       y={(this.state.sh * (( window.innerHeight < 825 ) ? 0.5 : 0.4 ) ) + Math.cos(i) * 5}
              //scale={this.state.scale}
                       width={this.state.width}
                       height={this.state.height}>

              <Sprite texture={this.props.texture[0]}
                      scale={[1,1]}
                      alpha={this.state.alpha}
                      anchor={this.state.anchor}
              />
              {this.generateRockBtns()}
              <Container name={"stone-numbers"}>
                {this.generateDigits()}
              </Container>
              <Text style={styleIndicator}
                /*
                x={50 - this.stoneBounds.w}
                y={140 - this.stoneBounds.h}
                anchor={[0,0]}
                text={'OUTPUT : ' + this.state.currentCodeEntered + ' ' + this.state.currentMsg + ' ' + this.state.isRepeatTriggered }
                */
              />
            </Container>
          )}
        </MoverWithApp>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layers/Rock.js